<script lang="tsx">

import {defineComponent, inject, provide, reactive, Transition} from 'vue';
import Icon from "@/components/common/icons/Icon.vue"
import Copy from "@/components/common/typography/Copy.vue";
import Toast from "@/components/common/toast/Toast.vue";

export const TOAST_PROVIDER = Symbol();

interface ToastProviderApi {
  displayToast: (text: string, durationMs?: number) => void
}

export default defineComponent({
  name: 'ToastProvider',
  inheritAttrs: false,
  components: {
    Toast,
    Copy,
    Icon
  },
  setup(props, context) {

    const state = reactive<{
      text: string,
      timeout: NodeJS.Timeout | undefined,
      visible: boolean
    }>({
      text: "",
      timeout: undefined,
      visible: false
    })

    const displayToast = (text: string, durationMs: number = 2000) => {
      if (state.timeout != undefined) {
        clearTimeout(state.timeout)
      }

      state.text = text;
      state.visible = true;

      state.timeout = setTimeout(() => {
        state.visible = false;
        state.timeout = undefined;
      }, durationMs);
    }

    provide<ToastProviderApi>(TOAST_PROVIDER, {
      displayToast
    })

    return () =>
      <>
        {context.slots.default?.()}

        <Transition name="fade">
          <Toast v-show={state.visible} text={state.text}/>
        </Transition>
      </>
  }
});

export const useToast = () => {
  const result = inject<ToastProviderApi>(TOAST_PROVIDER)
  if (result === undefined) {
    throw new Error("Cannot use Toast outside of ToastProvider")
  }
  return result
}

</script>

<style lang="scss">

.fade {
  &-enter {
    &-from {
      opacity: 0;
      transform: scale(0.75, 0.5625);
    }

    &-to {
      opacity: 1;
      transform: scale(1, 1);
    }

    &-active {
      transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 67ms;
    }
  }

  &-leave {
    &-from {
      opacity: 1;
      transform: scale(1, 1);
    }

    &-to {
      opacity: 0;
      transform: scale(0.75, 0.5625);
    }

    &-active {
      transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 67ms;
    }
  }

}

</style>
